import * as React from 'react';
type Props = {
  className?: string;
};
export function CaretLeft({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-caret-left"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43196 11.3165L15.663 4L16.8782 5.3671L9.41615 12L16.8782 18.6329L15.663 20L7.43196 12.6835C7.23671 12.51 7.125 12.2612 7.125 12C7.125 11.7388 7.23671 11.49 7.43196 11.3165Z"
        fill="currentColor"
      />
    </svg>
  );
}
